import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { getDefaultFormState } from "react-jsonschema-form/lib/utils";
import { customFields } from "../../../FormComponents/Fields";
import { StepperComp as Stepper, StepComp as Step } from "react-jsonschemapath-form";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Loading,
  NavigationPrompt,
  IntlFieldTemplateComp as IntlFieldTemplate,
  customWidgetsComp as customWidgets,
} from "qjumpers.common.ui";
import deepmerge from "deepmerge";
import {
  addBasicApplication,
  getBasicJobUrlIdentifier,
  loadBasicApplicationConfidentialQuestionnaire,
  loadBasicApplicationConfidentialQuestionnaireAcceptanceStage,
  loadCandidateProfileData,
  loadJobForBasicApplication,
} from "../../../requests/basicapplications";
import { handleOAuthRedirect } from "../../../requests/users";
import schemaJson from "./schema.json";
import uiSchema1Json from "./uiSchema/1.json";
import emptyQuestionnaireSchemaJson from "./uiSchema/EmptyQuestionnaire.json";
import {
  checkJobExpiredAndApplicationAllowed,
  highlightRequiredQuestions,
  overridePopulateDataFromProfile,
  prePopulateDataFromCandidate,
  setCountryValidation,
  setCvAndCoverletterRequiredOrOptional,
} from "../ApplicationForm/applicationHelpers";
import { saveConfidentialQuestionnaireAnswers } from "../../../requests/applications";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { errorState } from "../../../recoil/error/atom";
import { toastMessageState } from "../../../recoil/toast/atom";
import { Button, Modal } from "react-bootstrap";
import { cloneDeep } from "lodash";
import { currentCandidateData } from "../../../recoil/candidate/atom";
import { updateApplicationInternalUiSchema } from "../utils";

const BasicApplicationForm = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const popError = useSetRecoilState(errorState);
  const popToast = useSetRecoilState(toastMessageState);
  const candidate = useRecoilValue(currentCandidateData);

  const params = useParams();
  const location = useLocation();
  const urlQueries = new URLSearchParams(location.search);

  const [formData, setFormData] = useState({});
  const [schema, setSchema] = useState(schemaJson);
  const [jobInvitationId, setJobInvitationId] = useState(urlQueries.get("jobinvitationid") || "");
  const [applicantSource, setSource] = useState(urlQueries.get("source") || "");
  const [confidentialQuestionnaireUiSchema, setConfidentialQuestionnaireUiSchema] = useState();
  const [confidentialQuestionnaireId, setConfidentialQuestionnaireId] = useState();
  const [submitConfidentialInfo, setSubmitConfidentialInfo] = useState(false);
  const [oauthRedirectUrlForThirdPartyProvider, setOauthRedirectUrlForThirdPartyProvider] = useState();
  const [init, setInit] = useState(false);
  const [identifier, setIdentifier] = useState();
  //const [confidentialQuestionnaireAcceptanceStage, setConfidentialQuestionnaireAcceptanceStage] = useState();

  const [uiSchema1] = useState(uiSchema1Json);

  const [job, setJob] = useState();
  const [organisationQuestionnaireUiSchema, setOrganisationQuestionnaireUiSchema] = useState();
  const [screeningQuestionnaireUiSchema, setScreeningQuestionnaireUiSchema] = useState();
  const [pristine, setPristine] = useState(true);
  const [checksum, setChecksum] = useState(new Date().getTime());
  const [stepNavigation, setStepNavigation] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [alertTitle, setAlertTitle] = useState();
  const [alert, setAlert] = useState(false);
  const [alertError, setAlertError] = useState(false);
  const [alertMessage, setAlertMessage] = useState();
  const code = urlQueries.get("code");

  const getQuestionnaireFrom = (questionnaireResponse, key) => {
    var questionnaireClone = cloneDeep(emptyQuestionnaireSchemaJson);
    questionnaireClone.content[0].content[0].key = key;
    questionnaireClone.content[0].content[0].schema["ui:options"].survey = JSON.parse(
      questionnaireResponse.model
    ).model;
    return {
      newSurveyUiSchema: questionnaireClone,
      questionnaireId: questionnaireResponse.id,
    };
  };
  const initialise = () => {
    if (params.jobId) {
      if (urlQueries.get("link")) {
        loadBasicApplicationConfidentialQuestionnaire(params.jobId).then((result) => {
          let confidentialQuestionnaire = getQuestionnaireFrom(result.data, "confidentialQuestionnaireAnswer.model");

          setConfidentialQuestionnaireId(result.data.id);
          setConfidentialQuestionnaireUiSchema(confidentialQuestionnaire.newSurveyUiSchema);
          setSubmitConfidentialInfo(true);
          setInit(true);
        });
      } else {
        handleOAuthRedirect(window.location.href, params.jobId).then((response) => {
          if (response.data?.url !== null) {
            setOauthRedirectUrlForThirdPartyProvider(response.data.url);
          }
        });
        loadBasicApplicationConfidentialQuestionnaireAcceptanceStage(params.jobId).then((result) => {
          //setConfidentialQuestionnaireAcceptanceStage(result.data.confidentialInformationAcceptanceStage);
          const confidentialQuestStage = result?.data?.confidentialInformationAcceptanceStage;
          getBasicJobUrlIdentifier(params.jobId)
            .then((result) => {
              setIdentifier(result.data.identifier);
              let newFormData = getDefaultFormState(
                schema,
                { application: { jobId: params.jobId } },
                schema.definitions
              );
              newFormData.source = applicantSource;
              newFormData.jobInvitationId = jobInvitationId;
              if (code && code !== null && code !== "") {
                loadCandidateProfileData(params.jobId, code).then((result) => {
                  const profile = result.data;
                  if (profile && profile !== null) {
                    popToast([
                      {
                        type: "success",
                        title: t("Application.Seek.Profile.Message"),
                      },
                    ]);
                  }
                  mountJob(params.jobId, newFormData, profile, confidentialQuestStage);
                });
              } else {
                mountJob(params.jobId, newFormData, null, confidentialQuestStage);
              }
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.log(error);
            });
        });
      }
    }
  };

  const isQuickApplication = (name) => {
    const elems = window.location.pathname.split("/").filter(String);
    return elems.length > 0 && elems[0] === name;
  };

  useEffect(() => {
    if (candidate || (isQuickApplication("quickapplications") && !candidate)) {
      initialise();
    }
  }, [candidate]);

  const showError = (title, message) => {
    popError([
      {
        type: "warning",
        title: title,
        message: message,
        confirmBtnText: t("Action.Ok"),
        confirmBtnBsStyle: "success",
        cancelBtnBsStyle: "default",
        onConfirm: () => {
          navigateToListView();
        },
      },
    ]);
  };

  const navigateToListView = (submitSuccess = false) => {
    window.onbeforeunload = null;
    if (!submitSuccess) {
      window.location = `http://${window.location.host}/jobs/details/${identifier}`;
    } else {
      setPristine(true);
      window.location = `http://${window.location.host}`;
    }
  };

  const mountJob = (jobId, newFormData, profileData = null, confidentialQuestStage) => {
    loadJobForBasicApplication(jobId).then((response) => {
      const result = response.data;
      if (!result) {
        showError(t("Applications.Error"), t("Form.Errors.ApplicationsClosed"));
      }
      checkJobExpiredAndApplicationAllowed(result, newFormData, history);

      let jobInvitationId = newFormData.jobInvitationId || "";
      newFormData.jobId = result?.id;
      //newFormData.address = this.initializeAddress(newFormData.address, result);
      newFormData = prePopulateDataFromCandidate(newFormData, result, candidate, true);
      let organisationQuestionnaire = null;
      let screeningQuestionnaire = null;
      let confidentialQuestionnaire = null;

      if (result?.screeningQuestionnaire) {
        screeningQuestionnaire = getQuestionnaireFrom(
          result.screeningQuestionnaire,
          "screeningQuestionnaireAnswer.model"
        );
        if (!newFormData.screeningQuestionnaireAnswer || !newFormData.screeningQuestionnaireAnswer.questionnaireId) {
          newFormData.screeningQuestionnaireAnswer = {
            questionnaireId: screeningQuestionnaire.questionnaireId,
          };
        }
        //screeningQuestionnaireUiSchema = screeningQuestionnaire.newSurveyUiSchema;
      }

      if (result?.confidentialQuestionnaire && confidentialQuestStage == 1) {
        confidentialQuestionnaire = getQuestionnaireFrom(
          result.confidentialQuestionnaire,
          "confidentialQuestionnaireAnswer.model"
        );
        if (
          !newFormData.confidentialQuestionnaireAnswer ||
          !newFormData.confidentialQuestionnaireAnswer.questionnaireId
        ) {
          newFormData.confidentialQuestionnaireAnswer = {
            questionnaireId: confidentialQuestionnaire.questionnaireId,
          };
        }
        //confidentialQuestionnaireUiSchema = confidentialQuestionnaire.newSurveyUiSchema;
      }

      if (result?.organisationQuestionnaire) {
        organisationQuestionnaire = getQuestionnaireFrom(
          result.organisationQuestionnaire,
          "organisationQuestionnaireAnswer.model"
        );
        if (
          !newFormData.organisationQuestionnaireAnswer ||
          !newFormData.organisationQuestionnaireAnswer.questionnaireId
        ) {
          newFormData.organisationQuestionnaireAnswer = {
            questionnaireId: organisationQuestionnaire.questionnaireId,
          };
        }
        //organisationQuestionnaireUiSchema = organisationQuestionnaire.newSurveyUiSchema;
      }
      let schemaAndFormData = setCountryValidation(schema, newFormData);
      if (profileData && profileData !== null && profileData !== "") {
        schemaAndFormData.formData = overridePopulateDataFromProfile(schemaAndFormData.formData, profileData);
      }
      var newSchema = setCvAndCoverletterRequiredOrOptional(result, schemaAndFormData.schema);
      updateApplicationInternalUiSchema(result.companyName, uiSchema1, t);
      setJob(result);
      setSchema(newSchema);
      setFormData(schemaAndFormData.formData);
      setScreeningQuestionnaireUiSchema(screeningQuestionnaire?.newSurveyUiSchema);
      setConfidentialQuestionnaireUiSchema(confidentialQuestionnaire?.newSurveyUiSchema);
      setOrganisationQuestionnaireUiSchema(organisationQuestionnaire?.newSurveyUiSchema);

      setJobInvitationId(jobInvitationId);
      setInit(true);
    });
  };

  const onFormStop = () => {
    setAlert(false);
    setAlertError(false);
    navigateToListView("");
  };

  const formPause = () => {
    setSubmitting(true);
    setChecksum(new Date().getTime());
  };

  const formPlay = (pristine = false) => {
    setSubmitting(false);
    setPristine(pristine);
    setChecksum(new Date().getTime());
  };

  const onFormDataChange = ({ formData: formDataInput }) => {
    let updatedFormData = deepmerge.all([formData, formDataInput]);

    if (formDataInput.qualification) {
      updatedFormData.qualification = formDataInput.qualification;
    }
    if (formDataInput.referee) {
      updatedFormData.referee = formDataInput.referee;
    }
    if (formDataInput.employment) {
      updatedFormData.employment = formDataInput.employment;
    }
    if (formDataInput.candidate) {
      updatedFormData.candidate = formDataInput.candidate;
    }

    if (formDataInput.cv === null) {
      updatedFormData.cv = {
        allowCvParsing: false,
      };
    }

    let countryValidation = setCountryValidation(schema, updatedFormData);
    //In case of NZ country default postal code is not set and hence it mark as required on UI
    if (
      countryValidation.formData?.address &&
      countryValidation.formData.address.countryCode !== "US" &&
      countryValidation.formData.address.countryCode !== "AU"
    ) {
      countryValidation.formData.address.postalCode = countryValidation.formData.address.postalCode
        ? countryValidation.formData.address.postalCode
        : "Default";
    }

    setFormData(countryValidation.formData);
    setPristine(false);
    setSchema(countryValidation.schema);
    setChecksum(new Date().getTime());
  };

  const showAlertError = (title, message) => {
    setAlertError(true);
    setAlertTitle(title);
    setAlertMessage(message);
  };

  const beforeSubmit = () => {
    popError([
      {
        type: "warning",
        title: t("Form.Application.Confirm.Title"),
        message: t("Form.Application.SubmitConfirmation"),
        confirmBtnText: t("Action.Submit"),
        showCancel: true,
        confirmBtnBsStyle: "success",
        cancelBtnBsStyle: "default",
        onConfirm: () => onSubmit(false),
      },
    ]);
  };

  const onSubmit = (updateProfile) => {
    formPause();
    let cloneFormData = cloneDeep(formData);
    cloneFormData.source = applicantSource;
    cloneFormData.jobInvitationId = jobInvitationId;
    // DEL Empty Document
    if (cloneFormData.cv) {
      if (!cloneFormData.cv.upload) {
        delete cloneFormData.cv;
      } else if (cloneFormData.cv.base64String) {
        delete cloneFormData.cv.base64String;
      }
    }
    // DEL Empty Document
    if (cloneFormData.coverLetter) {
      if (!cloneFormData.coverLetter.upload) {
        delete cloneFormData.coverLetter;
      } else if (cloneFormData.coverLetter.base64String) {
        delete cloneFormData.coverLetter.base64String;
      }
    }

    if (cloneFormData.organisationQuestionnaireAnswer) {
      if (!cloneFormData.organisationQuestionnaireAnswer.questionnaireId) {
        delete cloneFormData.organisationQuestionnaireAnswer;
      }
    }

    if (cloneFormData.screeningQuestionnaireAnswer) {
      if (!cloneFormData.screeningQuestionnaireAnswer.questionnaireId) {
        delete cloneFormData.screeningQuestionnaireAnswer;
      }
    }

    if (cloneFormData.confidentialQuestionnaireAnswer) {
      if (!cloneFormData.confidentialQuestionnaireAnswer.questionnaireId) {
        delete cloneFormData.confidentialQuestionnaireAnswer;
      }
    }

    if (cloneFormData.skills === "" || cloneFormData.skills === "undefined") {
      cloneFormData.skills = JSON.stringify(cloneFormData.skills);
    }

    if (cloneFormData.firstName) {
      cloneFormData.candidate.firstName = cloneFormData.firstName;
    }

    if (cloneFormData.lastName) {
      cloneFormData.candidate.lastName = cloneFormData.lastName;
    }

    if (cloneFormData.prefferedFirstName) {
      cloneFormData.candidate.prefferedFirstName = cloneFormData.prefferedFirstName;
    }

    if (cloneFormData.email) {
      cloneFormData.candidate.email = cloneFormData.email;
    }

    if (cloneFormData.primaryContactNumber) {
      cloneFormData.candidate.primaryContactNumber = cloneFormData.primaryContactNumber;
    }

    if (cloneFormData.secondaryContactNumber) {
      cloneFormData.candidate.secondaryContactNumber = cloneFormData.secondaryContactNumber;
    }

    if (cloneFormData.address) {
      cloneFormData.candidate.address = cloneFormData.address;
    }

    cloneFormData.jobId = params.jobId ? params.jobId : cloneFormData.jobId;

    addBasicApplication(updateProfile, cloneFormData)
      .then((resp) => {
        const result = resp.response.data;
        if (result == null) {
          formPlay(true);
          showAlertError(
            t("Applications.Add"),
            t("application.Actions.Add.Fail.Already.Message", { email: formData.email })
          );
        } else {
          popToast([
            {
              type: "success",
              title: t("application.Actions.Add.Success.Message"),
            },
          ]);
          navigateToListView(true);
        }
      })
      .catch(() => {
        popToast([]);
        formPlay(true);
      });
  };

  const onModalClose = () => {
    setSubmitConfidentialInfo(false);
    setInit(false);
    history.push("/applications");
  };

  const hideAlert = () => {
    setAlert(false);
  };

  const hideAlertError = () => {
    setAlertError(false);
    setAlertTitle(null);
    setAlertMessage(null);
  };

  const mandatoryQuestionsError = () => {
    popError([
      {
        type: "error",
        title: "Error Occured",
        message: "Fields marked with * are mandatory",
      },
    ]);
  };

  const updateConfidentialQuestionnaireAnswers = () => {
    formData.confidentialQuestionnaireAnswer.questionnaireId = confidentialQuestionnaireId;
    saveConfidentialQuestionnaireAnswers(params.jobId, formData.confidentialQuestionnaireAnswer)
      .then(() => {
        popToast([
          {
            type: "success",
            title: t("Action.submit.questionnaire.Success.Message"),
          },
        ]);
        setSubmitConfidentialInfo(false);
        setInit(false);
        history.push("/applications");
      })
      .catch((e) => {
        onModalClose();
      });
  };

  if (!init) {
    return <Loading className="loading-component" />;
  }

  let allUiSchemas = [uiSchema1];
  let steps = [
    {
      name: "Form.Application.PersonalDetails",
      subName: "Form.Application.Required",
      required: true,
      showRequired: false,
      title: "Form.Application.PersonalDetails",
      icon: "qjicon-profile",
      component: (
        <Step
          schema={schema}
          uiSchema={uiSchema1}
          onUpdate={onFormDataChange}
          noValidate={false}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          liveValidate={true}
          formData={formData}
        />
      ),
    },
  ];

  if (screeningQuestionnaireUiSchema) {
    allUiSchemas.splice(1, 0, screeningQuestionnaireUiSchema);
    //make questionnaire required
    schema.properties.screeningQuestionnaireAnswer.required = ["model"];

    steps.splice(1, 0, {
      name: "Form.ScreeningQuestionnaire.Tab",
      subName: "Form.Application.Required",
      required: true,
      showRequired: true,
      title: "Form.ScreeningQuestionnaire.Title",
      icon: "qjicon-tick",
      component: (
        <Step
          schema={schema}
          uiSchema={screeningQuestionnaireUiSchema}
          noValidate={false}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          onUpdate={onFormDataChange}
        />
      ),
    });
  }

  if (confidentialQuestionnaireUiSchema && !submitConfidentialInfo) {
    allUiSchemas.splice(1, 0, confidentialQuestionnaireUiSchema);
    //make questionnaire required
    schema.properties.confidentialQuestionnaireAnswer.required = ["model"];

    steps.splice(1, 0, {
      name: "Form.ConfidentialQuestionnaire.Tab",
      subName: "Form.Application.Required",
      required: true,
      showRequired: true,
      title: "Form.ConfidentialQuestionnaire.Title",
      icon: "qjicon-tick",
      component: (
        <Step
          schema={schema}
          uiSchema={confidentialQuestionnaireUiSchema}
          noValidate={false}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          onUpdate={onFormDataChange}
          liveValidate={true}
        />
      ),
    });
  }

  if (organisationQuestionnaireUiSchema) {
    allUiSchemas.splice(1, 0, organisationQuestionnaireUiSchema);
    //make questionnaire required
    schema.properties.organisationQuestionnaireAnswer.required = ["model"];

    steps.splice(1, 0, {
      name: "Form.OrganisationQuestionnaire.Tab",
      subName: "Form.Application.Required",
      required: true,
      showRequired: true,
      title: "Form.OrganisationQuestionnaire.Title",
      icon: "qjicon-tick",
      component: (
        <Step
          schema={schema}
          uiSchema={organisationQuestionnaireUiSchema}
          noValidate={false}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          onUpdate={onFormDataChange}
          liveValidate={true}
        />
      ),
    });
  }

  return (
    <div>
      {submitting ? (
        <div className="formLoader">
          <Loading className="loading-component" />
        </div>
      ) : null}
      {job?.allowApplyWith &&
      applicantSource !== "trademe" && applicantSource !== "TradeMe" && applicantSource !== "TRADEME" &&
      oauthRedirectUrlForThirdPartyProvider !== null &&
      oauthRedirectUrlForThirdPartyProvider !== "" ? (
        <div className="pull-right">
          <iframe
            frameBorder="0"
            width="230px"
            height="45px"
            src={"https://apply-with-seek-button.seek.com.au/white" + oauthRedirectUrlForThirdPartyProvider}></iframe>
        </div>
      ) : null}
      <NavigationPrompt when={!pristine} />
      <div className="job-detail">
        <div className="job-detail--header">
          <div className="row">
            <div className="col-md-8 col-xs-12">
              <h1>{job?.title}</h1>
            </div>
          </div>
        </div>
        <div>
          <div>
            <div className="row">
              <div className="col-xs-12">
                <Stepper
                  checksum={checksum}
                  preventEnterSubmission={true}
                  steps={steps}
                  prevBtnOnLastStep={true}
                  dontValidate={false}
                  formData={formData}
                  alwaysUpdate={true}
                  stepsNavigation={stepNavigation}
                  reviewSteps={false}
                  pristine={pristine}
                  showErrorList={true}
                  enableStepNavigation={() => {
                    setStepNavigation(true);
                  }}
                  highlightRequiredQuestions={highlightRequiredQuestions}
                  popError={() => {
                    popError([
                      {
                        type: "warning",
                        title: t("Form.Errors.Title"),
                        message: t("Form.Errors.PleaseCorrect"),
                        confirmBtnText: t("Action.Ok"),
                        confirmBtnBsStyle: "danger",
                        cancelBtnBsStyle: "default",
                      },
                    ]);
                  }}
                  actions={[
                    {
                      title: t("Action.Cancel"),
                      className: "btn btn-border btn-lg",
                      validate: false,
                      onClick: () => {
                        onFormStop();
                      },
                    },
                    {
                      title: t("Action.SubmitApplication"),
                      className: "btn btn-success btn-lg",
                      validate: true,
                      onClick: () => {
                        beforeSubmit();
                      },
                      disabled: submitting,
                      finalStep: true,
                    },
                  ]}
                  mandatoryQuestionsError={mandatoryQuestionsError}
                />

                {alert ? (
                  <SweetAlert
                    warning
                    showCancel
                    confirmBtnText={t("Form.Unsaved.Leave")}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title="Are you sure?"
                    onConfirm={onFormStop}
                    onCancel={hideAlert}>
                    {t("Form.Unsaved.Text")}
                  </SweetAlert>
                ) : null}
                {alertError ? (
                  <SweetAlert
                    warning
                    confirmBtnText={t("Modal.Close")}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title={alertTitle}
                    onConfirm={hideAlertError}>
                    {alertMessage}
                  </SweetAlert>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={submitConfidentialInfo} onHide={onModalClose}>
        <Modal.Header closeButton className="brand-primary">
          <Modal.Title>
            <div>{t("Form.ConfidentialQuestionnaire.Title")}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <Step
              schema={schema}
              uiSchema={confidentialQuestionnaireUiSchema}
              noValidate={false}
              fields={customFields}
              widgets={customWidgets}
              FieldTemplate={IntlFieldTemplate}
              onUpdate={onFormDataChange}
            />
          </div>
          <Button onClick={updateConfidentialQuestionnaireAnswers}>Submit</Button>
          <Button onClick={onModalClose}>Cancel</Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BasicApplicationForm;
